import { IconChevronLeft, IconChevronRight, IconLoader2 } from '@tabler/icons-react';
import { AllTranscriptsProps } from '@/types';
import useTranslation from '@/hooks/useTranslation';

interface NavigationControlsProps {
  onPrev: () => void;
  onNext: () => void;
  isPrevDisabled?: boolean;
  isNextDisabled?: boolean;
  isPrevLoading?: boolean;
  isNextLoading?: boolean;
  className?: string;
  isLoading?: boolean;
  selectedTranscript?: AllTranscriptsProps | null;
}

export default function NavigationControls({
  onPrev,
  onNext,
  isPrevDisabled = false,
  isNextDisabled = false,
  isPrevLoading = false,
  isNextLoading = false,
  className = '',
  isLoading = false,
  selectedTranscript,
}: NavigationControlsProps) {
  const { lang } = useTranslation();
  return (
    <div className={`flex items-center bg-white rounded-lg text-dark-text ${className}`}>
      <button
        disabled={isPrevDisabled}
        type="button"
        className={`flex items-center justify-center border border-black rounded-l-lg disabled:cursor-not-allowed h-9 w-9 ${
          isPrevLoading && 'pointer-events-none'
        }`}
        onClick={onPrev}
      >
        {isPrevLoading ? (
          <IconLoader2 className="animate-spin" size={18} />
        ) : (
          <IconChevronLeft size={18} />
        )}
      </button>

      <div className="flex items-center min-w-[120px] justify-center px-3 text-sm font-semibold border-t border-b border-black h-9">
        {isLoading ? (
          <IconLoader2 className="animate-spin" size={18} />
        ) : (
          <div className="flex items-center gap-1.5">
            <span>{lang.get('msg.participant')} </span>
            <span>{selectedTranscript?.respondent_index}</span>
          </div>
        )}
      </div>

      <button
        disabled={isNextDisabled}
        type="button"
        className={`flex items-center justify-center border border-black rounded-r-lg disabled:cursor-not-allowed h-9 w-9 ${
          isNextLoading && 'pointer-events-none'
        }`}
        onClick={onNext}
      >
        {isNextLoading ? (
          <IconLoader2 className="animate-spin" size={18} />
        ) : (
          <IconChevronRight size={18} />
        )}
      </button>
    </div>
  );
}
